<template>
    <div>
        <b-container fluid>
            <b-row class="text-center" align-h="center">
                <b-col cols="10">
                    <div v-if="this.$store.state.errorType === 'loading-form-data-error'">
                        <br/>
                        <h4>
                            {{ this.loadingFormErrorCaption }}
                        </h4>
                        <br/>
                        <span>{{ this.loadingFormErrorMessage }}</span>
                        <br/><br/>
                        <b-button type="submit" @click="handleTryAgainClick" variant="primary">Try Again</b-button>
                    </div>
                    <div v-else>
                        <br/>
                        <h4>
                            {{ this.generalErrorCaption }}
                        </h4>
                        <br/>
                        <span>{{ this.generalErrorMessage }}</span>
                        <br/><br/>
                        <b-button type="submit" @click="handleTryAgainClick" variant="primary">Try Again</b-button>
                    </div>

                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>

export default {
    
    data() {
        return {
            loadingFormErrorCaption: 'Difficulties Loading The Request Form',
            loadingFormErrorMessage: 'Sorry but we seem to be experiencing difficulties loading the request form. Please click the Try Again button below to reload the form. If you continue to experience difficulties please contact our Customer Support Center at 713-338-4801.',
            generalErrorCaption: 'Unexpected Error',
            generalErrorMessage: 'Sorry but we seem to be experiencing an unexpected error. Please click the Try Again button below to reload the application. If you continue to experience difficulties please contact our Customer Support Center at 713-338-4801.'
        } 
    },
    computed: {
    },
    created () {
    },
    mounted () {
        this.$store.commit('updateDataError', false, { root: true });
    },    
    methods: {
        handleTryAgainClick(evt) {
            evt.preventDefault();
            
            // *** The approach to dealing with an exception when loading the form is to reload the entire application.
            // This is because it is easier to start over with NO STATE than to re-initialize the controls given that
            // controls depend on other controls.

            var url = process.env.BASE_URL;
            window.location.href = url;
        },
    },
}
</script>

<style>
.error-message {
    padding-left: 50px !important;
    padding-right: 50px !important;
}
</style>